// ============================================================================
// FILE: src/modules/ticket/components/performance/charts/TicketVolumeChart.jsx
// PURPOSE:
//   Ticket volume snapshot (Created vs Closed)
// ============================================================================

import React from "react";

export default function TicketVolumeChart({ created, closed }) {
  const createdVal = Number(created) || 0;
  const closedVal = Number(closed) || 0;
  const max = Math.max(createdVal, closedVal, 1);

  return (
    <div
      style={{
        marginTop: 24,
        padding: 16,
        borderRadius: 12,
        background: "#f9fafb",
        border: "1px solid #e5e7eb",
      }}
    >
      <h4 style={{ marginBottom: 12 }}>Ticket Volume (Current Period)</h4>

      <div style={{ display: "flex", gap: 24, alignItems: "flex-end" }}>
        <div style={{ textAlign: "center" }}>
          <div
            style={{
              height: `${(createdVal / max) * 100}px`,
              width: 40,
              background: "#3b82f6",
              borderRadius: 6,
            }}
          />
          <div style={{ marginTop: 6, fontSize: 12 }}>Created</div>
          <strong>{createdVal}</strong>
        </div>

        <div style={{ textAlign: "center" }}>
          <div
            style={{
              height: `${(closedVal / max) * 100}px`,
              width: 40,
              background: "#16a34a",
              borderRadius: 6,
            }}
          />
          <div style={{ marginTop: 6, fontSize: 12 }}>Closed</div>
          <strong>{closedVal}</strong>
        </div>
      </div>

      <div style={{ marginTop: 8, fontSize: 12, color: "#6b7280" }}>
        Snapshot view for selected period (not a time-series trend).
      </div>
    </div>
  );
}
